<template>
  <div class="progress">
    <el-progress v-if="!type" :percentage="percentage" :show-text="false" :stroke-width="8" />
    <el-progress
      v-else
      :percentage="percentage"
      :show-text="false"
      :stroke-width="8"
      :status="type"
    />
  </div>
</template>

<script>
export default {
  name: 'Progress',
  props: {
    percentage: {
      type: Number,
      default: 0
    },

    type: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
.progress {
  width: 100%;
  background: rgba($alto, 0.3);
  border-radius: 8px;
  padding: 4px;

  &::v-deep .el-progress-bar__outer {
    background: transparent;
  }
}
</style>
